import slugify from 'slugify';

/**
 * Adapt value to use in ID attr
 */
export function navigationFormatId(value: string): string {
  return slugify(value, { lower: true, strict: true });
}

/**
 * Can remove specific characters from the beginning and end of text
 */
export function trim(str: string, chars: string | string[]): string {
  let start = 0;
  let end = str.length;

  while (start < end && chars.indexOf(str[start]) >= 0) ++start;

  while (end > start && chars.indexOf(str[end - 1]) >= 0) --end;

  return start > 0 || end < str.length ? str.substring(start, end) : str;
}
